module.exports = __webpack_public_path__ + "img/assurance.fa4ea63e.jpg";